module.exports = __webpack_public_path__ + "static/media/john-paul-constuction.afb5a96f.png";